import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../settings/config.json';
import { Button, Modal, Form, Input, Upload } from 'antd';
import { EditOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

function AllPoems() {
  const [poems, setPoems] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPoem, setCurrentPoem] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchPoems = async () => {
      try {
        const response = await axios.get(`/api/poems`);
        setPoems(response.data);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchPoems();

    const interval = setInterval(fetchPoems, 3000);
    return () => clearInterval(interval);
  }, []);

  const showEditModal = (poem) => {
    setCurrentPoem(poem);
    form.setFieldsValue({ name: poem.name, content: poem.content });
    setIsModalVisible(true);
  };

  const handleEditOk = async () => {
    try {
      const values = await form.validateFields();
      const formData = new FormData();

      formData.append('name', values.name);
      formData.append('content', values.content);

      if (values.audioUpload && values.audioUpload.fileList.length > 0) {
        formData.append('audioFiles', values.audioUpload.fileList[0].originFileObj);
      }

      const response = await axios.put(`/api/poems/${currentPoem._id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setPoems(poems.map(poem => poem._id === currentPoem._id ? response.data : poem));
      setIsModalVisible(false);
      setCurrentPoem(null);
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  const handleEditCancel = () => {
    setIsModalVisible(false);
    setCurrentPoem(null);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/poems/${id}`);
      setPoems(poems.filter(poem => poem._id !== id));
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  return (
    <div className='Poems'>
      {poems.length > 0 ? (
        <ul className='message-list'>
          {poems.map(poem => (
            <li key={poem._id} className='message-item'>
              {poem.photo && (
                <img 
                  src={`/api${poem.photo}`}
                  alt="Avatar" 
                  className='avatar mt-3'
                />
              )}
              <div className='message-details'>
                <p className='name text-white'>{poem.name}</p>
                <p className='message-content font-reqular text-white-50 spaces'>Şeir: <br /><p className='text-white font-reqular'>{poem.content}</p></p>
                <p className='date'>{new Date(poem.date).toLocaleString()}</p>
              </div>
              <Button 
                className='like-button me-2 text-warning'
                icon={<EditOutlined />}
                onClick={() => showEditModal(poem)}
              />
              <Button 
                className='like-button me-2 text-danger'
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(poem._id)}
              />
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <center className='mt-5'>
          <h2 className='text-gradient'>Oops...</h2>
          <h4 className='mt-3 text-secondary font-reqular'>Şeir yoxdur</h4>
          <br /><br /><br />
        </center>
      )}
      <Modal
        title="Şeir redaktə edin"
        visible={isModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
        >
          <Form.Item
            name="name"
            label="Ad"
            rules={[{ required: true, message: 'Введите имя' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="content"
            label="Şeir"
            rules={[{ required: true, message: 'Введите стих' }]}
          >
            <Input.TextArea rows={6} />
          </Form.Item>
          <Form.Item
              name="audioUpload"
              label="Audio"
              rules={[{ required: false }]}
            >
              <Dragger
                name="audioUpload"
                beforeUpload={() => false}
                multiple
                listType="text"
                onChange={({ fileList }) => {
                  form.setFieldsValue({ audioUpload: { fileList } });
                }}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Dragger>
            </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default AllPoems;